import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_CloseBtn = _resolveComponent("CloseBtn")!

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["form-popup glass-tile", {'popup-visible': _ctx.popupVisible}])
  }, [
    _createElementVNode("p", {
      class: "info-msg",
      ref: "infoMsg"
    }, _toDisplayString(_ctx.popupMsg), 513),
    _createVNode(_component_CloseBtn, {
      glassTile: false,
      onClick: _cache[0] || (_cache[0] = ($event: any) => (this.$emit('closePopup')))
    })
  ], 2))
}